import {
  BILLINGS_LOADING,
  BILLINGS_TRANS_LOADED,
  BILLINGS_SP_LOADED,
  BILLINGS_CREDITTED,
  BILLINGS_FAILED,
  BILLINGS_APPROVAL,
  BILLINGS_TRANS_EXPORTED,
  LOGOUT,
} from "../types";

import { createPaginated, editPaginated } from "../../helpers/reduxUtils";

const initialState = {
  loading: false,
  trans: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case BILLINGS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case BILLINGS_TRANS_EXPORTED:
      return {
        ...state,
        loading: false,
      };
    case BILLINGS_APPROVAL:
      return {
        ...state,
        loading: false,
        trans: editPaginated(state.trans, action.payload),
      };
    case BILLINGS_SP_LOADED:
    case BILLINGS_TRANS_LOADED:
      return {
        ...state,
        loading: false,
        trans: action.payload,
      };
    case BILLINGS_CREDITTED:
      return {
        ...state,
        loading: false,
        trans: createPaginated(state.trans, action.payload),
      };
    case BILLINGS_FAILED:
      return {
        ...state,
        loading: false,
      };
    case LOGOUT:
      return {
        ...state,
        trans: null,
      };
    default:
      return state;
  }
}

